import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  filePreview: {
    justifyContent: "space-between",
    width: "100%",
    border: `1px solid ${grey[300]}`,
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(3),
    backgroundColor: grey[100],
    padding: theme.spacing(0.5, 1),
    alignSelf: "stretch",
  },
  fileImage: {
    width: "40px",
    height: "40px",
    objectFit: "contain",
    marginRight: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
  },
  fileName: {
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: 1.5,
    color: "black",
  },
}));
